module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "background-color": "#f9fbff"
    }
  }, [_c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbarTimeout,
      "top": _vm.y === 'top',
      "bottom": _vm.y === 'bottom',
      "right": _vm.x === 'right',
      "left": _vm.x === 'left',
      "multi-line": _vm.mode === 'multi-line',
      "vertical": _vm.mode === 'vertical'
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.snackbarText) + "\n      "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "pink"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticStyle: {
      "margin-bottom": "-5px"
    }
  }, [_c('h3', [_vm._v("Add Genes")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "padding-top": "5px"
    }
  }, [_c('label', [_vm._v("Search Genes")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputAddGenes",
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Search gene (E.g. TCOF1)"
    },
    on: {
      "focus": _vm.ClearInputForNewSearch
    }
  }), _vm._v(" "), _c('typeahead', {
    attrs: {
      "match-start": "",
      "target": "#inputAddGenes",
      "data": _vm.genesData,
      "limit": parseInt(100),
      "item-key": "gene_name"
    },
    model: {
      value: (_vm.searchGenes),
      callback: function($$v) {
        _vm.searchGenes = $$v
      },
      expression: "searchGenes"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "btnColor",
    staticStyle: {
      "margin-top": "-0.35px",
      "text-transform": "none"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addGeneToList($event)
      }
    }
  }, [_vm._v("\n                    Add\n                  ")]), _vm._v("\n                  Or\n                  "), _c('v-btn', {
    staticStyle: {
      "margin-top": "-0.35px"
    },
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.copyPasteGenes = true
      }
    }
  }, [_c('v-icon', [_vm._v("edit")]), _vm._v("\n                      Paste/ add multiple genes\n                  ")], 1), _vm._v(" "), _c('br')], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.genes.length === 0) ? _c('div', [_c('v-card-title', [_c('h3', [_vm._v(_vm._s(_vm.IntroductionTextData.Title))])]), _vm._v(" "), _c('v-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.IntroductionTextData.Content)
    }
  })], 1) : _c('div', [_c('v-card-text', [_vm._v("\n                Genes:\n                "), _c('br'), _vm._v(" "), _vm._l((_vm.genes), function(gene, i) {
    return _c('v-chip', {
      key: i,
      attrs: {
        "disabled": "",
        "color": "primary",
        "text-color": "white",
        "close": ""
      },
      on: {
        "input": function($event) {
          _vm.remove(gene)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(i + 1) + ". " + _vm._s(gene) + "\n                ")])
  })], 2)], 1)])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "max-width": "400"
    },
    model: {
      value: (_vm.copyPasteGenes),
      callback: function($$v) {
        _vm.copyPasteGenes = $$v
      },
      expression: "copyPasteGenes"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    attrs: {
      "id": "enter-genes-input"
    }
  }, [_c('v-textarea', {
    attrs: {
      "id": "copy-paste-genes",
      "multi-line": "",
      "rows": "12",
      "label": "Enter gene names"
    },
    model: {
      value: (_vm.genesToApply),
      callback: function($$v) {
        _vm.genesToApply = $$v
      },
      expression: "genesToApply"
    }
  })], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onApplyGenes($event)
      }
    }
  }, [_vm._v("\n                Apply\n              ")]), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    nativeOn: {
      "click": function($event) {
        _vm.copyPasteGenes = false
      }
    }
  }, [_vm._v("\n                Cancel\n              ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "max-width": "400"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Warning")]), _vm._v(" "), _c('v-card-text', [(_vm.byPassedGenes.length > 2) ? _c('p', [_vm._v("\n                Bypassing unknown genes: " + _vm._s(_vm.byPassedGenes) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.dupGenes.length > 2) ? _c('p', [_vm._v("\n                Bypassing duplicate genes: " + _vm._s(_vm.dupGenes) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("\n                OK\n              ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "min-height": "500px"
    },
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3007c7dd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/app/components/pages/AddGenes.vue
// module id = 503
// module chunks = 0